// @ts-nocheck
/**
 * @generated
 * @file GreenchoiceHomeHeader (generated by DevLink)
 *
 * This file is generated by DevLink from a Webflow component. Manual edits are discouraged.
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
"use client";

import { DEVLINK_SCOPE_CLASS } from "./devlinkScope";
import Block from "./webflow_modules/Basic/components/Block";
import BlockContainer from "./webflow_modules/Layout/components/BlockContainer";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import Section from "./webflow_modules/Layout/components/Section";

/**
 * Props for {@link GreenchoiceHomeHeader}
 */
export type GreenchoiceHomeHeaderProps = {
  image?: string;
  link2?:
    | {
        href: string;
        preload?: "prerender" | "prefetch" | "none";
        target?: "_self" | "_blank";
      }
    | {
        popoverTarget?: string;
        popoverTargetAction: "toggle" | "show" | "hide";
      }
    | {
        modalTarget?: string;
        modalAction: "show" | "hide";
      };
  text1?: React.ReactNode;
  title?: React.ReactNode;
};

/**
 * GreenchoiceHomeHeader
 *
 * @see {@link https://sumthing-components.design.webflow.com | Source site in Webflow}
 */
export function GreenchoiceHomeHeader({
  image = "https://cdn.prod.website-files.com/69b0267439a032e2e74a11ea/69b93efd746c7805b9ed0f59_hier-groeit-natuur-voor-morgen.jpeg",

  link2 = {
    href: "/projects",
  },

  text1 = "Ontdek waar we de natuur ondersteunen, bekijk de laatste updates uit het veld en volg de resultaten van de natuurprojecten.",
  title = "Natuur voor Morgen LIVE",
}: GreenchoiceHomeHeaderProps) {
  return (
    <div
      className={DEVLINK_SCOPE_CLASS}
      style={{
        display: "contents",
      }}
    >
      <Section
        className={"section-greenchoice greenchoice-green"}
        grid={{
          type: "section",
        }}
        tag={"section"}
      >
        <BlockContainer
          className={"container-greenchoice"}
          grid={{
            type: "container",
          }}
          tag={"div"}
        >
          <Block className={"div-block-294"} tag={"div"}>
            <Block className={"vertical-flex-greenchoice _40"} tag={"div"}>
              <Heading className={"h1-greenchoice white"} tag={"h1"}>
                {title}
              </Heading>
              <Paragraph className={"paragraph-greenchoice white"}>
                {text1}
              </Paragraph>
              <Link
                block={"inline"}
                button={false}
                className={"button-greenchoice"}
                options={link2}
              >
                <Block tag={"div"}>{"Bekijk alle projecten"}</Block>
              </Link>
            </Block>
            <Block className={"div-block-295"} tag={"div"}>
              <Image
                alt={""}
                className={"image-greenchoice home-header"}
                height={"auto"}
                loading={"lazy"}
                src={image}
                width={"auto"}
              />
            </Block>
          </Block>
        </BlockContainer>
      </Section>
    </div>
  );
}
